import React, { useRef } from 'react';
// import { Route, Routes, useLocation, NavLink } from 'react-router-dom';
// import { useUserAPI } from '../../components/useUserAPI';
// import { SharedInfoContext } from '../../components/SharedInfoContextProvider';
import Slider from 'react-slick';

// import "../assets/slick.css";
// import "../assets/slick-theme.css";
// CSS
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// @import '~slick-carousel/slick/slick';
// @import '~slick-carousel/slick/slick-theme';

import styles from '../../styles/Intro.module.scss'


// import React, { useContext } from 'react';
// import DeviceContext from '../../components/DeviceContext';

export function Help(props) {
	const settings = {
		autoplay: false,
		speed: 600,
		dots: true,
		infinite: false,
		arrows: false,
		draggable: true,
		mobileFirst: true,
		// initialSlide: 0,
		touchThreshold: 50,
		verticalSwiping: false,
		slidesToShow: 1,
		centerMode: false,
		// variableWidth: true,
		slidesToScroll: 1
	}
	// const { os, browser, device } = useContext(DeviceContext);

	const sliderRef = useRef();

	// const onSlickNext = () => {
	// 	sliderRef.current.slickNext();
	// }

	// const StartShopping = () => {
	// 	if(!props.shoppingStData){
	// 		shoppingStartAPI(sharedInfo.storeCode);
	// 	}else{
	// 		props.setPage("shopping");
	// 	}
	// }

	// const BackHome = () => {
	// 	props.setPage("home")
	// 	// setOpen(true)
	// }

	// const sharedInfo = useContext(SharedInfoContext);
	// // const { token, updateToken } = useContext(SharedInfoContext);
	// const { shoppingStartAPI, data: shoppingStartData, loading: shoppingStartLoading, error: shoppingStartError } = useUserAPI();

	// useEffect(() => {
	// 	if(shoppingStartData){
	// 		if (shoppingStartData.data) { //SUCCESS
	// 			console.log(`【shoppingStartAPI】 transactionno: ${shoppingStartData.data.transactionno}`);
	// 			console.log(`【shoppingStartAPI】 token: ${shoppingStartData.data.token}`);
	// 			console.log(`【shoppingStartAPI】 bandColor: ${shoppingStartData.data.bandColor}`);
	// 			console.log(`【shoppingStartAPI】 runInterval: ${shoppingStartData.data.runInterval}`);
	// 			console.log(`【shoppingStartAPI】 bonusFlag: ${shoppingStartData.data.bonusFlag}`);
	// 			console.log(`【shoppingStartAPI】 lotteryFlag: ${shoppingStartData.data.lotteryFlag}`);

	// 			updateToken(shoppingStartData.data.token);
	// 			props.setPage("attention");
	// 			props.setShoppingStData(shoppingStartData);
	// 		}else{ //ERROR
	// 			console.log(`【shoppingStartAPI】 errorCode: ${shoppingStartData.errorCode}`);
	// 			console.log(`【shoppingStartAPI】 errorMessage: ${shoppingStartData.errorMessage}`);
	// 			console.log(`【shoppingStartAPI】 isSuccess: ${shoppingStartData.isSuccess}`);

	// 			props.setErrNum(`${shoppingStartData.errorCode}`);
	// 			props.setShowModal(true);
	// 			props.setErrTxt(`${shoppingStartData.errorMessage}`);
	// 		}
	// 	}
	// }, [shoppingStartData,shoppingStartLoading,shoppingStartError]);

	return (
		<>

		<div className={styles.introBox}>
		<Slider {...settings} ref={sliderRef} className={styles.introSlider}>
			<div className={styles.introSlider_box}>
				<div className={styles.introSlider_info}>
					<h2 className={styles.step_num}>
						<img src="/images/howto_step01.svg" alt="ステップ1" width="48" height="66"/>
					</h2>
					<figure className={styles.introSlider_img}>
						<img src="/images/howto_step01_img.svg" alt="" width="238" height="149"/>
					</figure>
					<p className={styles.introSlider_txt}>お買い上げする商品の<br/>バーコードをスキャン</p>
				</div>
			</div>
			<div className={styles.introSlider_box}>
				<h2 className={styles.step_num}>
					<img src="/images/howto_step02.svg" alt="ステップ2" width="48" height="66"/>
				</h2>
				<figure className={`${styles.introSlider_img} ${styles.introSlider_img02}`}>
					<img src="/images/howto_step02_img.svg" alt="" width="231" height="151"/>
				</figure>
				<p className={styles.introSlider_txt}>お支払いコードを<br/>スキャンしてお会計<br/>
				<small>※お買い物の内容を確認させていただくことがあります。</small></p>
			</div>
			<div className={styles.introSlider_box}>
				<h2 className={styles.step_num}>
					<img src="/images/howto_step03.svg" alt="ステップ3" width="48" height="66"/>
				</h2>
				<figure className={`${styles.introSlider_img} ${styles.introSlider_img03}`}>
					<img src="/images/howto_step03_img.svg" alt="" width="212" height="146"/>
				</figure>
				<p className={`${styles.introSlider_txt} ${styles.introSlider_txt02}`}>スマホに表示されるコードを<br/>ゲート画面にかざして完了</p>
			</div>
		</Slider>
		{/* <button className={`${styles.commonBtn01} ${styles.introSlider_startBtn}`} onClick={StartShopping}>お買い物をはじめる</button> */}
		{/* <button className={`${styles.commonBtn04} ${styles.introSlider_backBtn}`} onClick={BackHome}>スタート画面に戻る</button> */}
		</div>
		</>
	)
}
